module.exports = __webpack_public_path__ + "img/MA-HMI-3.48c6b7b2.png";